module.exports = __webpack_public_path__ + "img/10-2.3141c0d1.png";